import React from 'react'

import * as S from './styled'

const DescriptionPage = ({ text }) => <S.Description>{text}</S.Description>

export default DescriptionPage
